import { useQuery } from 'react-query';
import api from '@/utils/httpClient';

export interface EventHistoryDto {
	id: string;
	eventType: string;
	eventName: string;
	eventDate?: Date;
	status: string;
	comments?: string;
	sortOrder?: number;
	biopsyIsTissueAvailable?: boolean;
	biopsyCollectionSite: string;
}

export const getEventHistoriesForPatient = (patientId: string | undefined) => {
  return api
    .get(`/api/eventhistories/${patientId}/eventHistories`)
    .then((response) => response.data as EventHistoryDto[]);
};

export const useGetEventHistories = (patientId: string | undefined) => {
  return useQuery(['eventHistories', patientId], () => getEventHistoriesForPatient(patientId), {
    enabled: !!patientId
  });
};
